var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 66,
    viewBox: "0 0 62 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13_1132)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M31.8802 65.73C48.272 65.73 61.5602 52.4418 61.5602 36.05C61.5602 19.6582 48.272 6.37 31.8802 6.37C15.4884 6.37 2.2002 19.6582 2.2002 36.05C2.2002 52.4418 15.4884 65.73 31.8802 65.73Z",
    fill: "url(#paint0_radial_13_1132)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
    fill: "url(#paint1_linear_13_1132)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4098 20.81C35.4098 18 33.1398 15.73 30.3298 15.73H17.3398C14.5298 15.73 12.2598 18 12.2598 20.81V26.85C12.2598 29.66 14.5298 31.93 17.3398 31.93H30.3298C33.1398 31.93 35.4098 29.66 35.4098 26.85V20.81ZM27.7698 24.28L21.9498 27.16C21.7198 27.28 20.9498 27.12 20.9498 26.86V20.94C20.9498 20.68 21.7298 20.51 21.9598 20.64L27.5398 23.67C27.7598 23.82 27.9998 24.16 27.7698 24.28Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_13_1132",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.8835 36.0484) scale(29.6844 29.6844)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000057"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2482,
    stopColor: "#4C4C89",
    stopOpacity: 0.7518
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5193,
    stopColor: "#9898BB",
    stopOpacity: 0.4807
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.744,
    stopColor: "#D0D0E0",
    stopOpacity: 0.256
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9103,
    stopColor: "#F2F2F6",
    stopOpacity: 0.0897
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13_1132",
    x1: 7.0299,
    y1: 7.0299,
    x2: 40.9731,
    y2: 40.9731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B0000"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_1132"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 61.57,
    height: 65.73,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame3);
export default __webpack_public_path__ + "static/media/frame-3.42025a820c8d3483c95aeb3aa048bf5b.svg";
export { ForwardRef as ReactComponent };